// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"b61a1610","300":"95ef06e0","324":"e0a347fb","369":"b05be036","456":"d5a6ec7a","529":"3ad5d670","820":"1e33678b","853":"e3fdd5cf","858":"5ef7b1fe"}[chunkId] + ".chunk.js";
};